module.exports = __webpack_public_path__ + "img/Visa.03b2a5be.svg";